import styled, { css } from 'styled-components';

export type BadgeVariant = 'success' | 'neutral' | 'warning' | 'error' | 'info' | 'accent';

const variants = {
  success: css`
    background: var(--success-soft);
    color: var(--success);
  `,
  neutral: css`
    background: var(--gray-100);
    color: var(--gray-600);
  `,
  warning: css`
    background: var(--warning-soft);
    color: var(--warning);
  `,
  error: css`
    background: var(--error-soft);
    color: var(--error);
  `,
  info: css`
    background: var(--info-soft);
    color: var(--info);
  `,
  accent: css`
    background: var(--accent-100);
    color: var(--accent-700);
  `,
};

/** Badge di stato: <Badge $variant="success">Attivo</Badge> */
export const Badge = styled.span<{ $variant?: BadgeVariant }>`
  display: inline-flex;
  align-items: center;
  gap: var(--space-xs);
  padding: var(--space-xs) var(--space-sm);
  border-radius: var(--border-radius-sm);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  line-height: 1.2;
  white-space: nowrap;

  ${({ $variant = 'neutral' }: { $variant?: BadgeVariant }) => variants[$variant]}

  svg {
    width: 0.875em;
    height: 0.875em;
  }
`;

export default Badge;
